// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"d741c71a","453":"9840ec39"}[chunkId] + ".chunk.js";
};